import React, { FC } from 'react'
import SALink from 'components/SALink'
import { stripScriptTags } from 'lib/sanitize'
import ListConnector, { ConnectorProps as ListProps } from '../connectors/List'
import styles from './shows.module.scss'
import classNames from 'classnames'

const Component: FC<ListProps> = (props) => {
  const { isAdmin, isMobileScreen, showsIntro, showsItems } = props
  const shouldShowAdminLinks = isAdmin && !isMobileScreen
  // Create a list of VISIBLE shows
  // Some items will be hidden from display on the listing page.
  const filterShows = showsItems.filter(({ shouldList }) => shouldList)
  return (
    <div className={styles.wrapper}>
      <div data-type='shows-list'>
        <div data-type='shows-list-title-container'>
          <h1 className='defaultTypographyH1' data-type='title'>
            Digital Exhibitions
          </h1>
          <p className='defaultTypographySmall' data-type='intro'>
            {showsIntro}
          </p>
        </div>

        <div data-type='shows-list-item-container'>
          {filterShows.map((item, index) => {
            const { slug, title, listingImage, listingBlurb } = item
            const cleanListingBlurb = stripScriptTags(listingBlurb)
            return (
              <div data-type='shows-list-item' key={index}>
                <div data-type='shows-list-item-image'>
                  <SALink href={`/shows/${slug}`}>
                    <img src={listingImage} />
                  </SALink>
                </div>
                <div data-type='item-copy'>
                  <h5 className={classNames('defaultTypographyH5', 'defaultTextBold')}>
                    <SALink href={`/shows/${slug}`}>{title}</SALink>
                  </h5>
                  {shouldShowAdminLinks && (
                    <>
                      <span>
                        <SALink href='/ops/cms/shows'>Edit Show</SALink>
                      </span>
                    </>
                  )}
                  <p
                    className='defaultTypographySmall'
                    dangerouslySetInnerHTML={{
                      __html: cleanListingBlurb,
                    }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ListConnector(Component)
